////import { Spin } from 'antd';
//import { LoadingOutlined } from '@ant-design/icons';

//const antIcon = <LoadingOutlined spin height={100} />;
const CustomSpinner = (props: { title?: string }) => (
    <div className="" >
        <div className="waiterCnt">
            <div className="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            {props.title && <div style={{ fontWeight: "bold", color: "green" }}>{props.title} </div>}
        </div>
    </div>
);

export default CustomSpinner;